// extracted by mini-css-extract-plugin
module.exports = {"NewsSave":"NewsSave--3gV4h","header":"header--11tZv","content":"content--efzFD","wrap":"wrap--3MBIk","tips":"tips--2IAsW"};